<template>
  <div class="app-search" :style="rootStyle">
    <label :for="inputId" class="app-sr-only">{{ placeholder }}</label>
    <app-icon name="search" :size="16" class="app-search__icon" />
    <input
      :id="inputId"
      ref="input"
      type="search"
      class="app-input app-search__input"
      :class="{ 'app-search__input--filled': inner !== '' }"
      :value="inner"
      :placeholder="placeholder"
      autocomplete="off"
      enterkeyhint="search"
      v-bind="$attrs"
      @input="onInput"
      @keydown.enter="emitNow"
      @keydown.esc="onEsc"
    />
    <app-icon-button
      v-if="inner !== ''"
      class="app-search__clear"
      icon="x"
      label="Suche löschen"
      :boxed="false"
      @click="clear"
    />
  </div>
</template>

<script>
// Suche (Spezifikation 2.6) im Feldstil mit Lupe, verborgenem Label (= Platzhalter) und Löschen-× im Feld.
// v-model wie bisher; das input-Ereignis kommt entprellt (debounce, Standard 250 ms), Enter und × sofort.
// width: Grundbreite in px (240; Verkäufe, Benutzer, Exporte 260 – bei Touch höchstens 240), schrumpft bis 160.
// Neben der Flex-Basis auch als width gesetzt: In Leisten, die sich nach dem Inhalt bemessen (#toolbar-end), zählt
// sonst nur die Eigenbreite des Eingabefelds (etwa 196 px). Tablet hoch und Handy lassen die Suche weiter wachsen.
import AppIcon from './AppIcon.vue';
import AppIconButton from './AppIconButton.vue';

export default {
  name: 'AppSearch',
  components: { AppIcon, AppIconButton },
  inheritAttrs: false,
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: 'Suchen' },
    width: { type: [Number, String], default: 240 },
    debounce: { type: [Number, String], default: 250 }
  },
  data() {
    return { inner: this.value || '' };
  },
  computed: {
    inputId() {
      return 'app-search-' + this._uid;
    },
    rootStyle() {
      const touch = !!(this.$dichte && this.$dichte.touch);
      let w = Number(this.width) || 240;
      if (touch && w > 240) {
        w = 240;
      }
      return { flex: '0 1 ' + w + 'px', width: w + 'px' };
    }
  },
  watch: {
    value(v) {
      const text = v === null || v === undefined ? '' : String(v);
      this.lastValue = text;
      // laufende Eingabe nicht überschreiben
      if (!this.timer && text !== this.inner) {
        this.inner = text;
      }
    }
  },
  created() {
    this.timer = null;
    this.lastValue = this.inner;
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    onInput(e) {
      this.inner = e.target.value;
      clearTimeout(this.timer);
      const delay = Number(this.debounce) || 0;
      if (delay <= 0) {
        this.emitNow();
      } else {
        this.timer = setTimeout(this.emitNow, delay);
      }
    },
    emitNow() {
      clearTimeout(this.timer);
      this.timer = null;
      if (this.inner !== this.lastValue) {
        this.lastValue = this.inner;
        this.$emit('input', this.inner);
      }
    },
    clear() {
      this.inner = '';
      this.emitNow();
      this.focus();
    },
    onEsc(e) {
      if (this.inner !== '') {
        e.stopPropagation();
        this.clear();
      }
    },
    focus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    }
  }
};
</script>
